import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { getCommaSeparatedNumber } from '../../../../../utils/common';
import { getDepartments } from '../apis/department-apis';
import { DiscipleType } from '../types/disciple';
import styles from './AdminYCMS.module.css';

type Department = {
  id: number;
  name: string;
};

type Props = {
  newType: DiscipleType;
  setNewType: Dispatch<SetStateAction<DiscipleType>>;
  onAdd: () => void;
};

export const DiscipleTypeCreate = ({ newType, setNewType, onAdd }: Props) => {
  const [departments, setDepartments] = useState<Department[]>([]);
  const isAddDisabled = (newType.departmentId ?? 0) === 0 || newType.displayName === '' || !newType.target || newType.target === 0;

  useEffect(() => {
    getDepartments().then(setDepartments); // 부서 목록을 가져온다.
  }, []);

  return (
    <tr>
      <th className={styles.td_disciple}>추가</th>
      <td className={styles.td_disciple}>
        <select
          className={styles.textInput}
          value={newType.departmentId ?? 0}
          onChange={(e) => {
            const departmentId = Number(e.target.value);
            setNewType({
              ...newType,
              departmentId,
            });
          }}
        >
          <option value={0}>선택</option>
          {departments.map((dept) => (
            <option key={dept.id} value={dept.id}>
              {dept.name}
            </option>
          ))}
        </select>
      </td>
      <td className={styles.td_disciple}>
        <input
          type="text"
          className={styles.textInput}
          name="displayName"
          placeholder="제자명을 입력하세요"
          value={newType.displayName}
          onChange={(e) => setNewType({ ...newType, displayName: e.target.value })}
        />
      </td>
      <td className={styles.td_disciple}>
        <input
          type="text"
          className={styles.textInput}
          name="description"
          placeholder="설명을 입력하세요(선택)"
          value={newType.description}
          onChange={(e) => setNewType({ ...newType, description: e.target.value })}
        />
      </td>
      <td className={styles.td_disciple}>
        <input
          type="text"
          className={styles.textInput}
          name="target"
          placeholder="목표(명) 입력 *"
          required
          style={{ textAlign: 'right' }}
          value={newType.target ? getCommaSeparatedNumber(newType.target) : ''}
          onChange={(e) => {
            let result = e.target.value;
            result = result.replace(/^0/g, ''); // 첫 글자가 0이면 제거
            result = result.replace(/[^0-9]/g, ''); // 숫자만 남김
            setNewType({ ...newType, target: result ? Number(result) : undefined });
          }}
        />
      </td>
      <td className={styles.td_disciple}></td>
      <td className={styles.td_disciple}>
        <div style={{ width: '100%', padding: '0.2rem', boxSizing: 'border-box' }}>
          <button className={[styles.wideButton, isAddDisabled ? styles.disabled : ''].join(' ')} onClick={onAdd} disabled={isAddDisabled} style={{ width: '100%', boxSizing: 'border-box' }}>
            등록
          </button>
        </div>
      </td>
    </tr>
  );
};
